import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';

import NotFound from '@/views/NotFoundPage.vue';
import privateRoutes from "./privateRoutes";
const routes = [
  {
    path: '/',
    redirect: 'dashboard',
    component: DashboardLayout,
    children: privateRoutes
  },
  {
    path: '/',
    //redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "intranet" */ '../views/Pages/Login.vue'),
        meta: {
          public: true
        }
      },
      {
        path: '/reset/email',
        name: 'resetEmail',
        component: () => import(/* webpackChunkName: "intranet" */ '../views/Pages/Passwords/Email.vue'),
        meta: {
          public: true
        }
      },
      {
        path: '/reset/password/:token',
        name: 'resetPassword',
        component: () => import(/* webpackChunkName: "intranet" */ '../views/Pages/Passwords/Password.vue'),
        meta: {
          public: true
        }
      },
      { path: '*', component: NotFound }
    ]
  }
];

export default routes;
